import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { coaches as coachesApi } from "../services/api";

const LEVEL_LABEL = {
  beginner:     "初學者",
  intermediate: "中級",
  advanced:     "進階",
  all:          "全程度",
};

export default function CoachPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [coach, setCoach]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState("");

  useEffect(() => {
    coachesApi.get(id)
      .then(setCoach)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return (
    <div style={{ textAlign: "center", padding: 80 }}>
      <span className="spinner" style={{ margin: "0 auto" }} />
    </div>
  );

  if (error || !coach) return (
    <div style={{ padding: 40, textAlign: "center", color: "var(--muted)" }}>
      找不到此教練
    </div>
  );

  return (
    <div style={{ maxWidth: 640, margin: "0 auto", padding: "40px 24px" }}>

      {/* 返回 */}
      <button onClick={() => navigate("/")} style={{
        background: "none", color: "var(--muted)", fontSize: 14,
        cursor: "pointer", marginBottom: 24, display: "flex", alignItems: "center", gap: 6,
      }}>
        ← 返回首頁
      </button>

      <div className="card fade-up" style={{ padding: 32 }}>

        {/* 頭像與姓名 */}
        <div style={{ display: "flex", gap: 20, alignItems: "center", marginBottom: 24 }}>
          <div style={{
            width: 80, height: 80, borderRadius: "50%",
            background: "var(--ink)", color: "var(--white)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 32, flexShrink: 0, overflow: "hidden",
          }}>
            {coach.avatar_url
              ? <img src={coach.avatar_url} alt={coach.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              : coach.name?.[0]
            }
          </div>
          <div>
            <h1 style={{ fontSize: 28, marginBottom: 8 }}>{coach.name}</h1>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              {(coach.skill_levels || []).map(lvl => (
                <span key={lvl} className="badge badge-blue">{LEVEL_LABEL[lvl] || lvl}</span>
              ))}
            </div>
          </div>
        </div>

        {/* 簡介 */}
        {coach.bio && (
          <p style={{ color: "var(--ink2)", lineHeight: 1.8, marginBottom: 24 }}>
            {coach.bio}
          </p>
        )}

        {/* 資訊列 */}
        <div style={{ display: "flex", gap: 32, paddingTop: 20, paddingBottom: 20, borderTop: "1px solid var(--stone)", borderBottom: "1px solid var(--stone)", marginBottom: 24 }}>
          <div>
            <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 4 }}>教學經驗</div>
            <div style={{ fontWeight: 600 }}>{coach.years_experience} 年</div>
          </div>
          {coach.rating > 0 && (
            <div>
              <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 4 }}>評分</div>
              <div style={{ fontWeight: 600 }}>★ {Number(coach.rating).toFixed(1)}</div>
            </div>
          )}
          {coach.review_count > 0 && (
            <div>
              <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 4 }}>評價數</div>
              <div style={{ fontWeight: 600 }}>{coach.review_count} 則</div>
            </div>
          )}
        </div>

        {/* 社群連結 */}
        {(coach.instagram || coach.facebook || coach.line_id) && (
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 13, color: "var(--muted)", marginBottom: 10 }}>聯絡方式</div>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              {coach.instagram && (
                <a href={`https://instagram.com/${coach.instagram}`} target="_blank" rel="noreferrer"
                  style={{ fontSize: 13, color: "var(--ink2)", textDecoration: "none" }}>
                  📷 @{coach.instagram}
                </a>
              )}
              {coach.facebook && (
                <a href={`https://facebook.com/${coach.facebook}`} target="_blank" rel="noreferrer"
                  style={{ fontSize: 13, color: "var(--ink2)", textDecoration: "none" }}>
                  👤 Facebook
                </a>
              )}
              {coach.line_id && (
                <span style={{ fontSize: 13, color: "var(--ink2)" }}>
                  💬 LINE: {coach.line_id}
                </span>
              )}
            </div>
          </div>
        )}

        {/* 預約按鈕 */}
        <button
          className="btn btn-primary btn-full"
          style={{ height: 48, fontSize: 16 }}
          onClick={() => navigate("/booking")}
        >
          預約課程
        </button>

      </div>
    </div>
  );
}